import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import type { EduSchool } from '@common/types/edu-course.type';
import type { CollectionStateStatuses } from '@common/adapters/collections';

import * as EduSchoolsSelectors from './edu-schools.selectors';
import type { EduSchoolsCollectionState } from './edu-schools.reducer';

@Injectable()
export class EduSchoolsCollectionFacade {
    private readonly store: Store<EduSchoolsCollectionState> = inject(Store);

    public readonly eduSchools$: Observable<EduSchool[]> = this.store.select(EduSchoolsSelectors.selectEduSchools);
    public readonly isEduSchoolsEmpty$: Observable<boolean> = this.store.select(
        EduSchoolsSelectors.selectIsEduSchoolsEmpty
    );
    public readonly eduSchoolsStatuses$: Observable<CollectionStateStatuses> = this.store.select(
        EduSchoolsSelectors.selectEduSchoolsStatuses
    );

    public eduSchoolsBySiteId$(siteId: string): Observable<EduSchool[]> {
        return this.store.select(EduSchoolsSelectors.selectEduSchoolsBySiteId(siteId));
    }
}
